<nb-card class="dialog-card pre-inscricao-inscritos">
  <nb-card-header>
    <span class="titulo">Pré-inscritos</span>
    <span class="subtitulo" *ngIf="campanhaNome">{{ campanhaNome }}</span>
  </nb-card-header>

  <nb-card-body>
    <div class="filtros">
      <div class="campo campo--grupo">
        <label class="field-label" for="pi-grupo">Grupo</label>
        <nb-select id="pi-grupo" fullWidth placeholder="Todos os grupos" [(selected)]="grupoFiltro">
          <nb-option value="">Todos os grupos</nb-option>
          <nb-option *ngFor="let g of gruposDisponiveis" [value]="g">{{ g }}</nb-option>
        </nb-select>
      </div>

      <div class="campo campo--nome">
        <label class="field-label" for="pi-nome-filtro">Nome</label>
        <nb-form-field>
          <nb-icon nbPrefix pack="eva" icon="search-outline"></nb-icon>
          <input
            nbInput
            fullWidth
            id="pi-nome-filtro"
            name="nomeFiltro"
            placeholder="Nome do catequizando — Enter para buscar"
            [(ngModel)]="nomeFiltro"
            (keyup.enter)="buscarAgora()"
          />
        </nb-form-field>
      </div>

      <div class="campo campo--acoes">
        <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
          <nb-icon pack="eva" icon="search-outline"></nb-icon>
        </button>
        <button nbButton status="basic" size="small" type="button" *ngIf="temFiltro" (click)="limparFiltro()">
          Limpar
        </button>
      </div>
    </div>

    <div class="carregando" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando…</span>
    </div>

    <p class="erro" *ngIf="erro">{{ erro }}</p>

    <ng-container *ngIf="!carregando && !erro">
      <p class="resumo">
        <strong>{{ exibidos.length }}</strong>
        {{ exibidos.length === 1 ? 'pessoa' : 'pessoas' }}
        <span *ngIf="temFiltro"> · de {{ inscritos.length }} no total</span>
      </p>

      <div class="tabela-rolagem" *ngIf="exibidos.length">
      <table class="inscritos-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Grupo</th>
            <th class="col-num">Idade</th>
            <th>Telefone</th>
            <th>Atendimento</th>
            <th>Enviada em</th>
            <th class="col-acoes">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of exibidos">
            <td>{{ i.nomeCatequizando || '—' }}</td>
            <td>{{ i.grupoNome || '—' }}</td>
            <td class="col-num">{{ i.idadeApurada != null ? i.idadeApurada : '—' }}</td>
            <td class="col-nowrap">{{ telefone(i) }}</td>
            <!-- Inscrito anterior à agenda (27/09) não tem horário: travessão, não "sem horário". -->
            <td class="col-nowrap">{{ atendimento(i) }}</td>
            <td class="col-nowrap">{{ i.criadoEm ? (i.criadoEm | date: 'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td class="col-acoes">
              <div class="acoes">
              <button
                nbButton
                size="small"
                status="basic"
                appearance="outline"
                type="button"
                class="btn-reenviar"
                [disabled]="reenviandoId === i.id"
                [nbSpinner]="reenviandoId === i.id"
                (click)="reenviarConfirmacao(i)"
                title="Reenviar a confirmação para os e-mails da ficha"
              >
                <nb-icon pack="eva" icon="email-outline"></nb-icon>
                <span>Reenviar</span>
              </button>

              <button
                nbButton
                size="small"
                status="success"
                appearance="outline"
                type="button"
                [disabled]="!i.pessoaId || jaEfetivado(i)"
                (click)="efetivar(i)"
                [title]="
                  !i.pessoaId
                    ? 'Pré-inscrição sem pessoa no cadastro'
                    : jaEfetivado(i)
                      ? 'Matrícula efetivada nesta sessão'
                      : 'Escolher a turma e matricular'
                "
              >
                <nb-icon pack="eva" [icon]="jaEfetivado(i) ? 'checkmark-circle-2-outline' : 'person-add-outline'"></nb-icon>
                <span>{{ jaEfetivado(i) ? 'Matriculado' : 'Efetivar' }}</span>
              </button>

              <p class="resultado-reenvio" *ngIf="resultadoDe(i)">{{ resultadoDe(i) }}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <p class="vazio" *ngIf="!exibidos.length && !inscritos.length">
        Ninguém se pré-inscreveu nesta campanha ainda.
      </p>
      <p class="vazio" *ngIf="!exibidos.length && inscritos.length">
        Nenhum pré-inscrito casa com o recorte atual.
      </p>
    </ng-container>
  </nb-card-body>

  <nb-card-footer class="footer-actions">
    <button nbButton status="primary" size="medium" type="button" (click)="fechar()">Fechar</button>
  </nb-card-footer>
</nb-card>
